import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ConfiguracoesService {
	configuracoes: Array<string>;

	private fechaAuto: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		false
	);

	private menuAberto: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		true
	);

	constructor() {
		this.getConfig();
		this.updateConfig();
	}

	getMenuAberto(): Observable<boolean> {
		return this.menuAberto.asObservable();
	}

	toggleMenuAberto(): void {
		this.menuAberto.next(!this.menuAberto.value);
	}

	getFechaAuto(): Observable<boolean> {
		return this.fechaAuto.asObservable();
	}

	setConfig(config: string, value: boolean): void {
		if (value) {
			if (!this.configuracoes.includes(config)) {
				this.configuracoes.push(config);
			}
		} else {
			const index: number = this.configuracoes.indexOf(config);

			if (index !== -1) {
				this.configuracoes.splice(index, 1);
			}
		}

		localStorage.setItem(
			'configuracoes',
			JSON.stringify(this.configuracoes)
		);

		this.getConfig();
		this.updateConfig();
	}

	getConfig(): void {
		this.configuracoes = JSON.parse(localStorage.getItem('configuracoes'));

		if (this.configuracoes === null) {
			this.configuracoes = [];
		}
	}

	updateConfig(): void {
		this.fechaAuto.next(!!(this.configuracoes.indexOf('fechaAuto') !== -1));
	}

	getCalendarLocale(): object {
		return {
			monthNames: [
				'Janeiro',
				'Fevereiro',
				'Março',
				'Abril',
				'Maio',
				'Junho',
				'Julho',
				'Agosto',
				'Setembro',
				'Outubro',
				'Novembro',
				'Dezembro',
			],
			monthNamesShort: [
				'Jan',
				'Fev',
				'Mar',
				'Abr',
				'Mai',
				'Jun',
				'Jul',
				'Ago',
				'Set',
				'Out',
				'Nov',
				'Dez',
			],
			dayNames: [
				'Domingo',
				'Segunda',
				'Terça',
				'Quarta',
				'Quinta',
				'Sexta',
				'Sábado',
			],
			dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
			dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
			before: 'Antes',
			after: 'Depois',
			clear: 'Limpar',
			apply: 'Aplicar',
			accept: 'Sim',
			reject: 'Não',
			choose: 'Escolher',
			upload: 'Upload',
			cancel: 'Cancelar',
			today: 'Hoje',
			weekHeader: 'Smn',
		};
	}
}
